import type {
  ICollection,
  ICollectionApiResponse,
} from 'services/api/api.types';

export const transformCollectionResponse = <T>(
  response: ICollectionApiResponse<T>
): ICollection<T> => {
  const defaultTotalCount = 0;
  const defaultItems: T[] = [];
  const totalCount = response.totalItems || defaultTotalCount;
  const items = response.member || defaultItems;
  const view = response.view;
  const nextPage = view ? view.next : undefined;
  const prevPage = view ? view.previous : undefined;
  return { items, totalCount, nextPage, prevPage };
};
